import { gql } from '@apollo/client';

export const getListingsForPriorityQuery = gql`
    query getListingsForPriority($currentPage: Int, $searchList: String) {
      getListingsForPriority(currentPage: $currentPage, searchList: $searchList) {
        status
        count
        results {
          id
          title
          state
          city
          priority
          isPublished
        }
      }
    }
`;

export const updateListingPriorityMutation = gql`
    mutation updateListingPriority($id: Int, $priority: Int) {
      updateListingPriority(id: $id, priority: $priority) {
        status
      }
    }
`;
